<template>
  <div :class="{ 'hmd-list-page': true, 'has-header': hasHeaderSlot, 'has-footer': hasFooterSlot,'iframe-list':isIframe }">
    <div v-if="hasHeaderSlot" class="hmd-list-page__hd">
      <slot name="header"></slot>
    </div>

    <div v-if="hasBodySlot" class="hmd-list-page__bd">
      <slot name="body"></slot>
    </div>

    <div v-if="hasFooterSlot" class="hmd-list-page__ft">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Comment } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "HmdListPage",
  computed: {
    hasHeaderSlot() {
      return this.$slots.header && this.$slots.header().findIndex((o) => o.type !== Comment) !== -1;
    },

    hasBodySlot() {
      return this.$slots.body && this.$slots.body().findIndex((o) => o.type !== Comment) !== -1;
    },

    hasFooterSlot() {
      return this.$slots.footer && this.$slots.footer().findIndex((o) => o.type !== Comment) !== -1;
    },
  },
  setup() {
    const isIframe = window.self !== window.top;
    return {isIframe};
  }
});
</script>

<style lang="less">
@import "./index";
</style>
